// Packages
import Parallax, { destroyParallaxListeners } from './packages/parallax';
// Polyfills
import ResponsiveImagePolyfill from './polyfills/responsiveImage';
export default {
    parallax: Parallax,
    destroyParallax: destroyParallaxListeners,
    responsiveImagePolyfill: ResponsiveImagePolyfill,
}
